const _ = require('lodash');
const classNames = require('classnames');
const Container = require('swa-components-core/container');
const CorporateLandingHomePageDashboardFull = require('./dashboard/corporate-landing-home-page-dashboard-full');
const CorporateLandingHomePageDashboardLight = require('./dashboard/corporate-landing-home-page-dashboard-light');
const PropTypes = require('prop-types');
const React = require('react');
const TransitionContent = require('swa-components-core/transition-content');

class CorporateLandingHomePageDashboard extends React.Component {
    static propTypes = {
        animation: PropTypes.shape({
            delay: PropTypes.number,
            enabled: PropTypes.bool,
            phases: PropTypes.string,
            speed: PropTypes.string
        }),
        className: PropTypes.string,
        companyEnrolledRapidRewards: PropTypes.bool.isRequired,
        dashboardName: PropTypes.string.isRequired,
        rapidRewardsMaintenance: PropTypes.bool.isRequired,
        rewardsSummary: PropTypes.object,
        unusedFundsInd: PropTypes.bool
    };

    state = {
        animationStep: 'idle'
    };

    componentDidMount() {
        if (this.isAnimationEnabled()) {
            this.startAnimation();
        }
    }

    render() {
        let renderContent = (
            <Container className={this.getClass()}>
                {this.props.companyEnrolledRapidRewards ?
                    <CorporateLandingHomePageDashboardFull {...this.getDashboardFullProps()} /> :
                    <CorporateLandingHomePageDashboardLight {...this.getDashboardLightProps()} />}
            </Container>
        );

        if (this.isAnimationEnabled()) {
            renderContent = (
                <TransitionContent {...this.getTransitionContentProps()}>
                    {renderContent}
                </TransitionContent>
            );
        }

        return renderContent;
    }

    getClass = () => {
        const classes = {
            'corporate-landing-home-page-dashboard': true,
            'corporate-landing-home-page-dashboard_animation':
                ((this.state.animationStep === 'idle') && this.isAnimationEnabled())
        };

        return classNames(classes, this.props.className);
    };

    getTransitionContentProps = () => {
        const animationProps = this.props.animation;

        return {
            delay: animationProps.delay,
            phases: animationProps.phases,
            renderId: this.state.animationStep,
            speed: animationProps.speed
        };
    };

    getDashboardFullProps = () => {
        const { dashboardName, rapidRewardsMaintenance, unusedFundsInd } = this.props;

        return {
            availablePoints: _.get(this.props, 'rewardsSummary.totalAvailablePoints', undefined),
            dashboardName: dashboardName,
            rapidRewardsMaintenance: rapidRewardsMaintenance,
            unusedFundsInd: unusedFundsInd
        };
    };

    getDashboardLightProps = () => ({
        dashboardName: this.props.dashboardName
    });

    isAnimationEnabled = () => _.get(this.props, 'animation.enabled', false);

    // artificially changing the props to start the animation
    startAnimation = () => {
        this.setState({
            animationStep: 'inProgress'
        });
    };
}

module.exports = CorporateLandingHomePageDashboard;
